module.exports = __webpack_public_path__ + "img/tmp_logo.40205e15.jpg";